import { Fragment } from "react";

import { sortByKey } from "@notemeal/utils-sort";

import { ServingAmountViewChip } from "./Chip";

import { FullServingAmountFragment } from "../../types";

interface ServingAmountViewChipListProps {
  servingAmounts: readonly FullServingAmountFragment[];
  hideLimitedAccessWarning?: boolean;
  onRemoveServing?: (servingAmountId: string) => void;
}

export const ServingAmountViewChipList = ({ servingAmounts, hideLimitedAccessWarning, onRemoveServing }: ServingAmountViewChipListProps) => {
  const sortedServingAmounts = sortByKey(servingAmounts, "position");

  return (
    <Fragment>
      {sortedServingAmounts.map(sa => (
        <ServingAmountViewChip
          key={sa.serving.id}
          servingAmount={sa}
          hideLimitedAccessWarning={hideLimitedAccessWarning}
          onRemoveServing={onRemoveServing}
        />
      ))}
    </Fragment>
  );
};
